var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8707_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9681 9.27474H10.4264L11.0098 6.94141H8.9681V5.77474C8.9681 5.17391 8.9681 4.60807 10.1348 4.60807H11.0098V2.64807C10.8196 2.62299 10.1015 2.56641 9.34318 2.56641C7.75943 2.56641 6.63477 3.53299 6.63477 5.30807V6.94141H4.88477V9.27474H6.63477V14.2331H8.9681V9.27474Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8707_869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e51fd5c73a265cdf21bbf56476a37f1a.svg";
export { ForwardRef as ReactComponent };